import { render, staticRenderFns } from "./SendMessageCard.vue?vue&type=template&id=2ed247d2"
import script from "./SendMessageCard.vue?vue&type=script&lang=ts"
export * from "./SendMessageCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports